<template>
  <div class="app-page">
    <Header ref="header" helpURL="models/">
      <template #header-slot>
        <BreadcrumbNavigation />
      </template>
      <template #page-slot>
        <BreadcrumbSelectProjectAndDataset
          @project-changed="handleProjectChanged"
        />
      </template>
    </Header>
    <div class="main-page-div">
      <main class="main-display-area">
        <router-view />
      </main>
    </div>
  </div>
  <TasksModal />
</template>

<script setup>
import { ref, computed, provide, onBeforeMount } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import 'vue-toast-notification/dist/theme-sugar.css';
import Header from '@/components/Header.vue';
import BreadcrumbNavigation from '@/components/BreadcrumbNavigation.vue';
import TasksModal from '@/components/TasksStatusComponent/TasksModalV2.vue';
import BreadcrumbSelectProjectAndDataset from '@/components/BreadcrumbSelectProjectAndDataset.vue';
import { encodeIdToUid } from '@/assets/js/utils.js';

// Props
defineProps({
  projectId: [String, Number],
});

// Composables
const route = useRoute();
const router = useRouter();

// const $toast = useToast();
// const store = useStore();
// const route = useRoute();
// const router = useRouter();

// // Refs and state
// const experiments = ref(null);
// const dataConnect = new DatastoreConnect();

// const currentProject=ref(null);
// const currentExperiment = ref(null);  
// const currentSession = ref(null);

// // Computed properties
// // const currentProject = computed({
// //   get() {
// //     return store.state.projects.currentProject;
// //   },
// //   set(value) {
// //     store.commit('projects/setCurrentProject', value);
// //   },
// // });

// // const currentExperiment = computed({
// //   get() {
// //     return store.state.experiments.currentExperiment;
// //   },
// //   set(exp) {
// //     store.commit('experiments/setCurrentExperiment', exp);
// //   },
// // });

// // const currentSession = computed({
// //   get() {
// //     return store.state.experiments.currentSession;
// //   },
// //   set(session) {
// //     store.commit('experiments/setCurrentSession', session);
// //   },
// // });

// // Provide for child components
// provide('experiments', computed(() => experiments.value));

// // Methods
// async function getExperiment(id) {
//   return dataConnect.getExperiment({ trainer_id: id })
//     .then(async (data) => {
//       if (!data.result) {
//         throw data.error.message;
//       }
//       return data.result;
//     })
//     .catch((error) => {
//       $toast.open({
//         queue: true,
//         dismissible: true,
//         message: `Failed to retrieve experiment: ${error}`,
//         type: 'error',
//         position: 'top',
//       });
//     });
// }

// async function getTrainingSession(training_session_id) {
//   return dataConnect.getTrainingSession({ trainer_session_id: training_session_id })
//     .then(async (data) => {
//       if (!data.result) {
//         throw data.error.message;
//       }

//       const date1 = new Date(data.result.deleted);
//       const date2 = new Date('0001-01-01T00:00:00Z');
//       if (date1 > date2) {
//         $toast.open({
//           queue: true,
//           dismissible: true,
//           message: `Failed to retrieve training session: Session has been removed`,
//           type: 'error',
//           position: 'top',
//         });
//         return null;
//       }
//       return data.result;
//     })
//     .catch((error) => {
//       $toast.open({
//         queue: true,
//         dismissible: true,
//         message: `Failed to retrieve training session: ${error}`,
//         type: 'error',
//         position: 'top',
//       });
//     });
// }

// async function getExperiments() {
//   if (currentProject.value) {
//     const resp = await dataConnect.getExperimentList({ project_id: currentProject.value.id })
//       .catch((error) => {
//         $toast.open({
//           queue: true,
//           dismissible: true,
//           message: `Failed to retrieve experiments: ${error}`,
//           type: 'error',
//           position: 'top',
//         });
//       });
//     if (!resp || resp.error || !resp.result) {
//       $toast.open({
//         queue: true,
//         dismissible: true,
//         message: `Failed to retrieve experiments: ${resp.error.message}`,
//         type: 'error',
//         position: 'top',
//       });
//       return [];
//     }
//     return resp.result;
//   }
//   return [];
// }

async function handleProjectChanged(projectId) {
  if (projectId) {
    // Encode project ID to UID format (p-xxx)
    const encodedProjectId = `p-${Number(projectId).toString(16)}`;
    const currentRouteProjectId = route.params.projectId;

    // Only navigate if the encoded project ID is different from current route
    if (currentRouteProjectId !== encodedProjectId) {
      // Generate and push the ExperimentList URL
     router.push({ name: 'experiments', params: { projectId: encodeIdToUid(projectId, 'p') } });
    }
  }
}

// // Lifecycle hooks
// onBeforeMount(async () => {
//   // Project is already set by router.beforeEach guard, so we don't need to set it here
//   // Just handle the experiment and session params from route
//   if (route.query.exp_id) {
//     const experiment_id = parseInt(route.query.exp_id);
//     const experiment = await getExperiment(experiment_id);
//     if (experiment) {
//       currentExperiment.value = experiment;
//     }
//   } else {
//     currentExperiment.value = null;
//   }

//   if (route.query.train_session_id) {
//     const train_session_id = parseInt(route.query.train_session_id);
//     const trainingSession = await getTrainingSession(train_session_id);
//     if (trainingSession) {
//       currentSession.value = trainingSession;
//     }

//     if (currentSession.value && !currentExperiment.value) {
//       const experiment = await getExperiment(currentSession.value.trainer_id);
//       if (experiment) {
//         currentExperiment.value = experiment;
//       }
//     }
//   } else {
//     currentSession.value = null;
//   }
// });
</script>

<style lang="scss" scoped>

.main {
  height: 100vh;
}
</style>
